import React, { useEffect, useState } from 'react';
import { subscribe } from './notify';

// Rendert Toasts (oben rechts) und ein Bestätigungs-Modal. Einmal in App montiert.
function NotificationHost() {
  const [toasts, setToasts] = useState([]);
  const [confirmReq, setConfirmReq] = useState(null);

  useEffect(() => {
    return subscribe((action) => {
      if (action.kind === 'toast') {
        const t = action.toast;
        setToasts((prev) => [...prev, t]);
        if (t.timeout) {
          setTimeout(() => setToasts((prev) => prev.filter((x) => x.id !== t.id)), t.timeout);
        }
      } else if (action.kind === 'confirm') {
        setConfirmReq(action.confirm);
      }
    });
  }, []);

  const dismissToast = (id) => setToasts((prev) => prev.filter((x) => x.id !== id));
  const resolveConfirm = (value) => {
    if (confirmReq) confirmReq.resolve(value);
    setConfirmReq(null);
  };

  const bg = (type) => ({
    success: 'text-bg-success',
    danger: 'text-bg-danger',
    warning: 'text-bg-warning',
    info: 'text-bg-primary',
  }[type] || 'text-bg-primary');

  return (
    <>
      {/* Toasts */}
      <div
        className="position-fixed top-0 end-0 p-3"
        style={{ zIndex: 11000, maxWidth: 'min(92vw, 420px)' }}
      >
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`toast show align-items-center border-0 mb-2 ${bg(t.type)}`}
            role="alert"
            aria-live="assertive"
          >
            <div className="d-flex">
              <div className="toast-body" style={{ whiteSpace: 'pre-wrap' }}>{t.message}</div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                aria-label="Schließen"
                onClick={() => dismissToast(t.id)}
              ></button>
            </div>
          </div>
        ))}
      </div>

      {/* Bestätigungs-Modal */}
      {confirmReq && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ background: 'rgba(0,0,0,0.5)', zIndex: 11050 }}
          onClick={(e) => { if (e.target === e.currentTarget) resolveConfirm(false); }}
        >
          <div className="card shadow-lg border-0 mx-3" style={{ maxWidth: '420px', width: '100%', borderRadius: '14px' }}>
            <div className="card-body p-4">
              <h5 className="fw-bold mb-2">{confirmReq.title}</h5>
              <p className="mb-4" style={{ whiteSpace: 'pre-wrap' }}>{confirmReq.message}</p>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-outline-secondary" onClick={() => resolveConfirm(false)}>
                  {confirmReq.cancelText}
                </button>
                <button
                  type="button"
                  className={`btn ${confirmReq.danger ? 'btn-danger' : 'btn-primary'}`}
                  onClick={() => resolveConfirm(true)}
                  autoFocus
                >
                  {confirmReq.confirmText}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default NotificationHost;
